// Bewaart de laatst bekende PresentationSession (incl. session_token) per
// sessie-id in sessionStorage, zodat een reload van het beamer- of
// bedieningsscherm op hetzelfde apparaat blijft werken zonder opnieuw te
// hoeven koppelen. Er bestaat geen GET /sessions/{id} in de backend (sectie
// 31 van docs/sprekers-Module.md) -- de volledige sessie is alleen
// beschikbaar via de create/connect-respons zelf, dus dit is de enige plek
// waar hij bewaard kan worden voor een latere reload op hetzelfde apparaat.
// Een ander apparaat dat dezelfde link opent zonder dit ooit zelf te hebben
// aangemaakt/gekoppeld kan de sessie hierdoor bewust niet herstellen.
import type { PresentationSession } from './types';

const KEY_PREFIX = 'sprekers_live_session_';

export function persistLiveSession(session: PresentationSession): void {
  try {
    window.sessionStorage.setItem(`${KEY_PREFIX}${session.id}`, JSON.stringify(session));
  } catch {
    // sessionStorage kan ontbreken (bijv. privénavigatie) -- live modus werkt
    // dan nog steeds, alleen zonder reload-herstel.
  }
}

export function readLiveSession(sessionId: string): PresentationSession | null {
  try {
    const raw = window.sessionStorage.getItem(`${KEY_PREFIX}${sessionId}`);
    return raw ? (JSON.parse(raw) as PresentationSession) : null;
  } catch {
    return null;
  }
}
